<template>
    <div class="dispensing-item-preview">
        <div class="action mb-5">
            <span>{{ t('patients::dispensing.form.title.dispensing_schedule') }}</span>
        </div>
        <v-btn
            :disabled="readOnlyRules"
            color="primary"
            class="mr-5"
            small
            outlined
            rounded
            @click="openModal('singleStageDialog')"
            >{{ t('patients::button.single_stage') }}</v-btn
        >
        <v-btn
            :disabled="readOnlyRules"
            color="primary"
            small
            outlined
            rounded
            @click="openModal('standardStageDialog')"
            >{{ t('patients::button.standard_stage') }}</v-btn
        >
        <v-dialog v-model="singleStageDialog" width="500">
            <v-card>
                <v-card-title>{{ t('patients::modal.title.single') }}</v-card-title>
                <v-card-text>
                    <v-form ref="singleStageForm" v-model="singleStageForm" :disabled="readOnlyRules">
                        <b-date-picker-store
                            to-mutate="patients::dispensingForm.blood_result_date"
                            :label="t('patients::dispensing.form.label.blood_result_date')"
                            :rules="validationRules.singleStageForm.blood_result_date"
                            mandatory
                        ></b-date-picker-store>
                        <b-select
                            to-mutate="patients::dispensingForm.frequency"
                            :label="t('patients::dispensing.form.label.frequency')"
                            :select-items="frequencyItems"
                            :rules="validationRules.singleStageForm.frequency"
                            mandatory
                        ></b-select>
                        <b-textarea
                            rows="2"
                            to-mutate="patients::dispensingForm.reason"
                            :label="t('patients::dispensing.form.label.reason')"
                            :rules="validationRules.singleStageForm.reason"
                            mandatory
                        ></b-textarea>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary" outlined rounded :disabled="!singleStageForm" @click="generateSchedule">{{
                        t('patients::button.generate')
                    }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <v-dialog v-model="standardStageDialog" width="500">
            <v-card>
                <v-card-title>{{ t('patients::modal.title.standard') }}</v-card-title>
                <v-card-text>
                    <v-form ref="standardStageForm" v-model="standardStageForm">
                        <b-date-picker-store
                            to-mutate="patients::dispensingForm.blood_result_date"
                            :label="t('patients::dispensing.form.label.blood_result_date')"
                            :rules="validationRules.standardStageForm.blood_result_date"
                            mandatory
                        ></b-date-picker-store>
                        <b-textarea
                            rows="2"
                            to-mutate="patients::dispensingForm.reason"
                            :label="t('patients::dispensing.form.label.reason')"
                            :rules="validationRules.standardStageForm.reason"
                            mandatory
                        ></b-textarea>
                    </v-form>
                </v-card-text>
                <v-card-actions>
                    <v-btn color="primary" outlined rounded :disabled="!standardStageForm" @click="generateSchedule">{{
                        t('patients::button.generate')
                    }}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
export default {
    props: {
        readOnlyRules: {
            type: Boolean,
            required: true,
            default: false,
        },
    },
    data() {
        return {
            singleStageDialog: false,
            standardStageDialog: false,
            singleStageForm: false,
            standardStageForm: false,
            validationRules: {
                singleStageForm: {
                    schedule_type: [(v) => !!v || t('users::validation.field.required')],
                    frequency: [(v) => !!v || t('users::validation.field.required')],
                    blood_result_date: [(v) => !!v || t('users::validation.field.required')],
                    reason: [(v) => !!v || t('users::validation.field.required')],
                },
                standardStageForm: {
                    schedule_type: [(v) => !!v || t('users::validation.field.required')],
                    blood_result_date: [(v) => !!v || t('users::validation.field.required')],
                    reason: [(v) => !!v || t('users::validation.field.required')],
                },
            },
            frequencyItems: [
                { value: 'weekly', text: t('patients::dispensing.form.frequency_items.weekly') },
                { value: '2_weekly', text: t('patients::dispensing.form.frequency_items.2_weekly') },
                { value: '4_weekly', text: t('patients::dispensing.form.frequency_items.4_weekly') },
            ],
        };
    },
    computed: {
        patientId() {
            return this.$store.state.patients.patient.id;
        },
        dispensingForm() {
            return this.$store.state.patients.dispensingForm;
        },
    },
    created() {},
    mounted() {},
    methods: {
        generateSchedule() {
            // this.$store.dispatch('patients/setDispensingLoading', true);
            const scheduleType = this.dispensingForm.schedule_type;
            const data = {
                blood_result_date: this.dispensingForm.blood_result_date,
                reason: this.dispensingForm.reason,
                frequency: this.dispensingForm.frequency,
                schedule_type: this.dispensingForm.schedule_type,
            };
            if (scheduleType === 'standard') {
                delete data.frequency;
            }
            return axios
                .post(
                    route('api.v1.patients.dispensing-schedules.store', {
                        patient: this.patientId,
                    }),
                    {
                        ...data,
                    }
                )
                .then(() => {
                    this.standardStageDialog = false;
                    this.singleStageDialog = false;
                    this.$store.dispatch('patients/resetDispensingForm');
                })
                .catch((error) => {
                    this.$store.dispatch('patients/setDispensingLoading', false);
                    if (error.response && error.response.status === 422) {
                        this.$store.dispatch('patients/setErrorMessages', {
                            isDispensingForm: true,
                            errors: error.response.data.errors,
                        });
                    } else {
                        this.$root.notify('error', error.response.data.error);
                    }
                })
                .finally(() => {
                    // this.$store.dispatch('patients/setDispensingLoading', false);
                });
        },
        openModal(modal) {
            this.$store.dispatch('patients/resetErrorMessages');
            switch (modal) {
                case 'singleStageDialog':
                    this.$store.dispatch('patients/updateProperty', {
                        property: 'dispensingForm.schedule_type',
                        value: 'single',
                    });
                    this.singleStageDialog = true;
                    break;
                case 'standardStageDialog':
                    this.$store.dispatch('patients/updateProperty', {
                        property: 'dispensingForm.schedule_type',
                        value: 'standard',
                    });
                    this.standardStageDialog = true;

                    break;
                default:
                    break;
            }
        },
    },
};
</script>
